"use strict"

import React, {useEffect} from "react"
import {observer} from "mobx-react"
import moment from "moment"
import {injectIntl} from "react-intl"
import {Container, Box, Grid, Typography, Tabs, Tab} from "@material-ui/core"
import XsTable from "../../global/ui/xsTable/xsTable"
import SettingsStore from "./settingsStore"
import RegistrationsWithoutRequest from "./registrationsWithoutRequest"
import XsButton from "../../global/ui/xsButton/xsButton"
import CallRoundDialog from "./callRoundDialog"
import CallRoundDialogStore from "./callRoundDialogStore"
import {isBOAdmin} from "../../global/helpers/actions"

const columns = [
	{
		Header: "Región",
		width: 80,
		accessor: "region_type_code_ext"
	},
	{
		Header: "Skupina zariadenia",
		width: 100,
		accessor: "device_group_name_ext"
	},
	{
		Header: "Platnosť od",
		width: 120,
		accessor: "validity_from",
		Cell: (props) => <div>{isNotEmpty(props.value) ? moment(props.value).format("DD.MM.YYYY HH:mm") : ""}</div>
	},
	{
		Header: "Štart",
		width: 120,
		accessor: "start",
		Cell: (props) => <div>{isNotEmpty(props.value) ? moment(props.value).format("DD.MM.YYYY HH:mm") : ""}</div>
	},
	{
		Header: "Platnosť do",
		width: 120,
		accessor: "validity_to",
		Cell: (props) => <div>{isNotEmpty(props.value) ? moment(props.value).format("DD.MM.YYYY HH:mm") : ""}</div>
	},
	{
		Header: "Alokácia",
		width: 100,
		align: "right",
		accessor: "allocation",
		Cell: (props) => (
			<div>{new Intl.NumberFormat("sk-SK", {style: "currency", currency: "EUR"}).format(props.value)}</div>
		)
	},
	{
		Header: "Posledná zmena (Kto)",
		width: 120,
		accessor: "updated_by"
	}
]

function SettingsContainer() {
	useEffect(() => {
		SettingsStore.tabValue = "settings"
		SettingsStore.getSettings()
		SettingsStore.getRegistrationsWithoutRequest()
	}, [])

	const handleChange = (event, newValue) => {
		SettingsStore.tabValue = newValue
	}

	return (
		<Container maxWidth="lg">
			<Grid container justify="space-between" alignItems="center" className="pt-8">
				<Grid item>
					<Typography variant="h4">Nastavenia</Typography>
				</Grid>
			</Grid>
			<Box pt={2}>
				<Tabs value={SettingsStore.tabValue} onChange={handleChange} indicatorColor="primary" textColor="primary">
					<Tab label="nastavenia výzvy" value="settings" />
					<Tab label="registrácie BEZ žiadosti" value="registrations" />
				</Tabs>
				{SettingsStore.tabValue === "settings" && (
					<Grid container className="pt-8">
						<Grid item container xs={12} justify="flex-end">
							<Grid item>
								<XsButton
									text="Pridať kolo výzvy"
									disabled={!isBOAdmin()}
									icon={<i className="fas fa-plus"></i>}
									onClick={() => CallRoundDialogStore.open()}
								/>
							</Grid>
						</Grid>
						<Grid item xs={12}>
							<Box pt={1}>
								<XsTable
									columns={columns}
									data={SettingsStore.settingsData}
									onRowClick={(row) => (isBOAdmin() ? CallRoundDialogStore.open(row) : null)}
								/>
							</Box>
						</Grid>
					</Grid>
				)}
				{SettingsStore.tabValue === "registrations" && <RegistrationsWithoutRequest />}
			</Box>
			<CallRoundDialog />
		</Container>
	)
}

export default injectIntl(observer(SettingsContainer))

